import React from 'react';
import PropTypes from 'prop-types';
import { getArrayForTable } from 'components/common/DraftEditor/util/tableHelper';

const TableWrapper = (props) => {
  const { editorState, children } = props;
  const table = getArrayForTable(editorState, children, props['data-offset-key']);

  return (
    <div className="editor-table-block">
      <div className="editor-table-wrapper">
        <div className="editor-table-scroll">
          <table>
            {table.map((row, index) => (
              <tr key={index}>
                {row.map((item, itemIndex) =>
                  row.length - 1 !== itemIndex
                    ? React.cloneElement(item, {
                        'data-table-cell': item.key,
                      })
                    : React.cloneElement(item, {
                        style: { display: 'none' },
                        contentEditable: false,
                      }),
                )}
              </tr>
            ))}
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableWrapper;

TableWrapper.propTypes = {
  children: PropTypes.array,
  editorState: PropTypes.object,
  'data-offset-key': PropTypes.string,
};
